import { BRAND_SOCIAL_MECHANIC_SELECTION_LIMIT } from "@runcheetah/shared/brand-profile";

export { BRAND_SOCIAL_MECHANIC_SELECTION_LIMIT as CONTENT_DNA_MECHANIC_SELECTION_LIMIT };

export function toggleContentDnaMechanic(input: {
  selected: readonly string[];
  mechanic: string;
  unavailable?: readonly string[];
  limit?: number;
}): string[] {
  const {
    selected,
    mechanic,
    unavailable = [],
    limit = BRAND_SOCIAL_MECHANIC_SELECTION_LIMIT,
  } = input;

  if (selected.includes(mechanic)) {
    return selected.filter((value) => value !== mechanic);
  }

  if (selected.length >= limit || unavailable.includes(mechanic)) {
    return [...selected];
  }

  return [...selected, mechanic];
}
